import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsPlanEntryTaxiDriverDraftResponseDataContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionOther =
  {
    type: BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverDraftResponseDataBonusContribution =
  | BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionOther;

export type BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContribution =
  | BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverDraftResponseDataContribution =
  | BillingsPlanEntryTaxiDriverDraftResponseDataBonusContribution
  | BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContribution
  | BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationFleetPartner =
  {
    name: string;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverUser =
  {
    firstName: string;
    lastName: string;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverStartingAddress =
  {
    displayName: string;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriver =
  {
    user: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverUser;
    startingAddress: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverStartingAddress;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociation =
  {
    driver: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriver;
    fleetPartner: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationFleetPartner | null;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataContract = {
  model: string;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociation;
  description: string;
};

export type BillingsPlanEntryTaxiDriverDraftResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: string | null;
  checkoutEventId: string | null;
  plannedDate: string | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrder =
  {
    cargoOrder: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder;
  };

export type BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrder = {
  transportingOrder: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrder;
};

export type BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntry = {
  humanId: number;
  solvedOrders: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrder[];
};

export type BillingsPlanEntryTaxiDriverDraftResponseData = {
  contract: BillingsPlanEntryTaxiDriverDraftResponseDataContract;
  billingNodes: BillingsPlanEntryTaxiDriverDraftResponseDataBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverDraftResponseDataContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntry: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntry;
  date: Date;
  passengers: string[];
  rateForDistance: number;
  correctedContractModel: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

type BillingsPlanEntryTaxiDriverDraftResponse =
  HttpResponse<BillingsPlanEntryTaxiDriverDraftResponseData>;

export default BillingsPlanEntryTaxiDriverDraftResponse;
